import { onboardingApi } from "@/redux/apis/onboarding/onboardingApi";
import { businessApi } from "../businessApi";
import { transformGetEmailNotifications, transformUpdateEmailNotifications } from "./helpers";
import { GetEmailNotificationsResponse, UpdateEmailNotificationsParams, UpdateEmailNotificationsResponse } from "./types";

export const emailNotificationsApi = businessApi.enhanceEndpoints({ addTagTypes: ["EmailNotifications"] }).injectEndpoints({
  endpoints: (builder) => ({
    getEmailNotifications: builder.query<GetEmailNotificationsResponse, void>({
      query: () => `/notifications`,
      transformResponse: transformGetEmailNotifications,
      providesTags: ["EmailNotifications"],
    }),
    updateEmailNotifications: builder.mutation<UpdateEmailNotificationsResponse, UpdateEmailNotificationsParams>({
      query: (body) => ({
        url: `/notifications`,
        method: "PUT",
        body: body,
      }),
      transformResponse: transformUpdateEmailNotifications,
      invalidatesTags: ["EmailNotifications"],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(onboardingApi.endpoints.getOnboardingStatus.initiate(undefined, { forceRefetch: true }));
        } catch {
          console.error("Failed to update email notifications");
        }
      },
    }),
  }),
});

export const { useGetEmailNotificationsQuery, useUpdateEmailNotificationsMutation } = emailNotificationsApi;
